import { useAuth } from "../auth/AuthContext";

export default function useUserId(): [string | undefined, boolean] {
  const { user, loading } = useAuth();
  return [user?.id, loading];
}
